import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSearchBarModule } from './../../../../@fuse/components/search-bar/search-bar.module';
import { FuseShortcutsModule } from './../../../../@fuse/components/shortcuts/shortcuts.module';
import { FuseSharedModule } from './../../../../@fuse/shared.module';
import { ToolbarComponent } from './toolbar.component';
import { ToolbarComponentDynamic } from './toolbar-dynamic/toolbar-dynamic.component';
import { PlatformBreadCrumbModule } from '../../../../../app-platform-breadcrumb';
@NgModule({
    declarations: [ToolbarComponent, ToolbarComponentDynamic],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        PlatformBreadCrumbModule
    ],
    exports: [ToolbarComponent, ToolbarComponentDynamic]
})
export class ToolbarModule {}
